import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useReducer,
  useRef,
} from "react";

import _find from "lodash/find";
import { withTranslation } from 'react-i18next';

// utils
import api from "utils/api";
// hooks
import history from "utils/history";
import _local from "utils/localStorageUtils";
import useDeviceDetect from "utils/useDeviceDetect";
import { getObjId } from "utils/helpers/helper.general";
import { isDateBeforeToday } from "utils/moment/moment.utils";

// capacitor
import { default as appPushNotifications } from "appCapacitor/helpers/pushNotifications";
import { default as appHelper } from "appCapacitor/helpers/helper.capacitor";
import { default as appStatusBar } from "appCapacitor/helpers/helper.statusBar";

/**
 * Context for Notifications
 */
const initState = {
  _id: null,
  username: false,
  email: false,
  language: "",
  abbreviationName: "",
  description: false,
  address: false,
  image: false,
  role: false,
  name: false,
  searchName: false,
  userAuth: false,
  isTourFinished: false,
  registrationTokens: [],
  amountAbsences: 0,
  lastOpenedApp: "",
  childsNotifications: [],
  students: [],
  activeChild: false,
  // absence, only for parents
  activeChildHasSickness: false,
  activeChildSicknessAbs: false,
  activeChildAbsences: false,
  // teacher
  schoolsNotifications: [],
  school: false,
  schools: [],
  activeSchool: null, // "Toute l'école"
};
const reducer = (s, v) => ({ ...s, ...v });

const UserContext = createContext();
const UserDispatchContext = createContext();

export const useStateUser = () => {
  const user = useContext(UserContext);
  if (!user) {
    throw Error("useStateUser must be call withing UserProvider");
  }
  return user;
};

export const useDispatchUser = () => {
  const setUser = useContext(UserDispatchContext);
  if (!setUser) {
    throw Error("useDispatchUser must be call withing UserProvider");
  }
  return setUser;
};

export const UserProvider = ({ children }) => {
  let UserProviderData = {};

  const [user, setUser] = useReducer(reducer, initState);
  const [token, setToken] = useState("");
  // for active/checked child (for parents)
  const [pushNotifData, setPushNotifData] = useState(null);

  const [childChange, setChildChange] = useState(false);
  const [logOutTimer, setLogOutTimer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { isMobile } = useDeviceDetect();

  const publicPaths = [
    "/signupparent",
    "/reset",
    "/activation",
    "/confirm",
    "/404",
  ];

  // check if open page for online
  // if detail page => is on open page except community detail page
  UserProviderData.isPublicPath = useCallback(() => {
    const pathname = window.location.pathname;
    const isPath = publicPaths.some(p => pathname.includes(p));
    if (!!isPath) {
      return true;
    } else {
      return false;
    }
  }, []);

  UserProviderData.initUser = useCallback(async () => {
    const localUser = _local.getLocalUser();

    // redirect to another libk if user do not logined
    if (!!!localUser?._id) { 
      setIsLoading(false);
      // redirect to another libk if user do not logined
      if (UserProviderData.isPublicPath()) {
        return false;
      } else {
        history.push("/login");
      }
    }

    // get user data and store in the context
    else {

      _local.setLocalData("logout", false);
      setToken(localUser?.token);
      // api.setAuthorizationHeader(localUser?.token);
      if (!isLoading && !!localUser?._id) {
        setIsLoading(true);

        // TODO: mange this part for getting separate request for getting user data for: mobile and web (desctop versions)
        // mobile: api.users.getByID() // for parents get children from all schools
        // desctop (web): api.users.getByIDBySchool() // for parents get children from one (active) school
        try {
          const userInitData = await api.users.getByID(localUser?._id);

          setIsLoading(false);

          if (userInitData?._id) {
            const mergedUserData = { ...user, ...userInitData };
            setUser(mergedUserData);
            // on first load of data set active child
            if (mergedUserData?.role == "parent") {
              /*       let parentData = data;
              const children = data?.students?.length == 0 && await api.users.getParentChildren(data?._id)
              if (children?.length > 0) {
                parentData.students = children
              } */
              UserProviderData.setIniChild(mergedUserData);
            } else if (mergedUserData?.role == "teacher" || mergedUserData?.role == "admin") {
              UserProviderData.setIniSchool(mergedUserData);
            }
          }

        } catch (err) {
          setIsLoading(false);
          UserProviderData.setIniSchool();
          console.error(err);
        }
    
      }

    }

  }, [history, localStorage, user]);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    //console.log('-- context !!!')
    UserProviderData.initUser();
    return () => {
      logOutTimer && clearTimeout(logOutTimer);
    };
  }, []);

  /*  useEffect(() => {
    if (pushNotifData && Object.keys(pushNotifData).length > 0) {
      const { absenceId, childId, notifAmount } = pushNotifData;
      if (!!absenceId) {
        //UserProviderData.agregateAbcenseNotification(pushNotifData);
      } else {
        if (user?.activeChild?._id == childId) {
          // UserProviderData.changeChild(user?.activeChild);
        } else if (!!childId) {
          user?.students?.map(child => {
            if (child?._id == childId) {
              // console.debug('params child?._id: ', JSON.stringify(child?._id))
              UserProviderData.changeChild(child);
            }
          });
        }
      }
    }
  }, [pushNotifData, user?.activeChild?._id]); */

  UserProviderData.agregateAbcenseNotification = useCallback(
    pushNotifData => {
      const { absenceId, childId, absStatus, notifAmount } = pushNotifData;
      if (absenceId && childId && !absStatus) {
        if (user?.activeChild?._id == childId) {
          UserProviderData.changeChild(user?.activeChild, absenceId);
        } else {
          user?.students?.map(child => {
            if (child?._id == childId) {
              // console.debug('params child?._id: ', JSON.stringify(child?._id))
              UserProviderData.changeChild(child, absenceId);
            }
          });
        }
      } else if (absenceId && childId && absStatus) {
        if (user?.activeChild?._id == childId) {
          UserProviderData.changeChild(user?.activeChild);
        } else {
          user?.students?.map(child => {
            if (child?._id == childId) {
              // console.debug('params child?._id: ', JSON.stringify(child?._id))
              UserProviderData.changeChild(child);
            }
          });
        }
      }
    },
    [pushNotifData, user?.activeChild, user?.students],
  );

  /**
   * User Core
   */
  UserProviderData.setAutorization = useCallback(
    auth => {
      setUser({ ...user, userAuth: auth ? true : false });
      auth && _local.setLocalData("logout", false);
    },
    [setUser, user],
  );

  UserProviderData.isAuthenticated = useCallback(() => {
    const localUser = _local.getLocalUser();
    return !!localUser?.token;
  }, []);

  UserProviderData.loginUser = useCallback(
    async userData => {
      _local.setLocalData("logout", false);
      let newUser = { ...initState, ...userData };
      setUser(newUser);
     // console.debug("WEB - REGISTRATION", {user, userData});
      //console.debug('WEB - REGISTRATION:', appHelper.isWeb, userData?.role, userData?.token);
      // api.setAuthorizationHeader(userData?.token);

      if (userData?.role == "parent") {
        await UserProviderData.setIniChild(newUser);
      } else if (userData?.role == "teacher" || userData?.role == "admin") {
        await UserProviderData.setIniSchool(newUser);
      }

      if (!appHelper.isWeb) {
        console.debug("Capacitor - REGISTRATION");
        await UserProviderData.askPermissionsOnDevice();
        await appPushNotifications.registerPush();
        await appHelper.askRecordAudioPermission();
      }
    },
    [user, appHelper.isWeb],
  );

  UserProviderData.askPermissionsOnDevice = useCallback(async () => {
    if (!appHelper.isWeb) {
      console.debug("Capacitor - REGISTRATION PERMISSIONS: camera and audio");
      appHelper.askCameraPermissions();
    }
  }, [user, appHelper.isWeb]);

  UserProviderData.patchUser = useCallback(
    async userData => {
      if (!!userData?._id) {
        const userResult = await api.users.update(userData);
        if (userResult) {
          setUser({ ...user, ...userResult });
        } else {
          console.error("patchUser Error");
        }
      } else {
        console.error('patchUser Error: inside userData don`t have "_id"');
      }
    },
    [user],
  );

  /**
   * User School
   */
  UserProviderData.setIniSchool = async userData => {
    const localSchool = _local.getLocalSchool();
    const localSchools = _local.getLocalSchools();
    const localUser = _local.getLocalUser();
    const userSchools = initState?.schools || localUser?.schools || [];
    //console.log('setIniSchool', {userSchools, data}, data?.role)
    if (userSchools?.length > 0 || userData?.schools?.length > 0) {
      const rootSchools = userData?.schools?.length > 0 ? userData?.schools : userSchools;
      let newUser = { ...user, ...userData };
      if (!localSchool) {
        newUser = {
          ...newUser,
          schools: rootSchools,
          activeSchool: rootSchools[0],
        };
        _local.setLocalActiveSchool(rootSchools[0]);
      } else {
        const school =
          rootSchools?.find(sc => sc?.key === localSchool?.key) ||
          rootSchools[0];
        newUser = { ...newUser, schools: rootSchools, activeSchool: school };
        _local.setLocalActiveSchool(school);
      }
      // TODO: only for mobile version
      if (
        localUser?.role == "teacher" &&
        (!appHelper.isWeb || appHelper.isWeb)
      ) {
        const notifications =
          (await api.notifications.teacher.getSchoolsNotifications(
            getObjId(localUser),
          )) || [];
        // console.log({notifications})
        newUser = { ...newUser, schoolsNotifications: notifications };
      }
      setUser(newUser);
    } else {
      const newUser = {
        ...user,
        ...userData,
        schools: localSchools || [],
        activeSchool: localSchool || null,
      };
      setUser(newUser);
      _local.setLocalActiveSchool(localSchool || null);
      if (
        localUser?.role == "teacher" &&
        (!appHelper.isWeb || appHelper.isWeb)
      ) {
        await UserProviderData.getSchoolsNotifications(newUser);
      }
    }
    return userSchools;
  };

  // for mobile
  UserProviderData.changeSchoolByKey = useCallback(
    async schoolKey => {
      const localUser = _local.getLocalUser();
      if (localUser?.role == "teacher") {
        const userSchools = user?.schools || localUser?.schools || [];
        const school = userSchools?.find(school => school?.key == schoolKey);
        _local.setLocalActiveSchool(school);

        let newUser = { ...user, schools: userSchools, activeSchool: school };
        let notifs = user?.schoolsNotifications || [];

        const result = await api.notifications.teacher.getSchoolNotifications(
          getObjId(localUser),
          school?.key,
        );
        if (!!result) {
          const hasSchool =
            !!result && notifs?.find(n => n?.key == result?.key);
          notifs = !!hasSchool
            ? notifs?.map(n => (n?.key == result?.key ? result : n))
            : [...notifs, result];
        }

        newUser = { ...newUser, schoolsNotificationsnotifs: notifs };
        setUser(newUser);

        return school;
      } else {
        return null;
      }
    },
    [user],
  );

  /**
   * User Children
   */
  UserProviderData.setIniChild = async userData => {
    const localUser = _local.getLocalUser();
    const localChild = _local.getLocalChild();
    const userStudents = initState?.students || localUser?.students || user?.students || [];
    //console.log('setIniChild', {localUser, userStudents, userData}, userData?.role)
    if (userData?.role == "parent" || localUser?.role == "parent") {
      let students = userStudents;
      if (userStudents?.length > 0 || userData?.students?.length > 0) {
        students = userData?.students?.length > 0 ? userData?.students : userStudents;
      } else {
        //console.log('load students')
        try {
          students = (await api.users.getParentChildren(localUser?._id)) || students;
        } catch (err) {
          console.error(err);
        }
      }
     // console.log({ students })

      if (!!students && students?.length > 0) {
        let newUser = { ...user, ...userData };
       // console.log({newUser})
        if (!localChild) {
          newUser = {
            ...newUser,
            students,
            activeChild: students[0],
          };
          _local.setLocalActiveChild(students[0]);
          // setup students list
          setUser(newUser);
        } else {
          const std =
            students?.find(sc => sc?._id === localChild?._id) || students[0];
          newUser = { ...newUser, students, activeChild: std };
          _local.setLocalActiveChild(std);
          // setup students list
          setUser(newUser);
        }

        // TODO: only for mobile version
        if (!appHelper.isWeb || appHelper.isWeb) {
          const notifications =
            (await api.notifications.parent.getChildrenNotifications(
              getObjId(localUser),
            )) || [];
          // console.log({notifications})
          newUser = { ...newUser, childsNotifications: notifications };
          setUser(newUser);
        }
      }
    } else {
      setUser({ ...user, ...userData, students: [], activeChild: false });
      _local.setLocalChild({});
    }
  };

  UserProviderData.changeChild = useCallback(
    async (child, absId = null) => {
      console.log("UserProviderData.changeChild");
      console.debug("UserProviderData.changeChild", absId);
      setUser({ ...user, activeChild: child });
      _local.setLocalActiveChild(child);
      // await UserProviderData.changeActiveChildAbsence(child, absId);
      await UserProviderData.getChildNotification(child);
      return child;
    },
    [user],
  );

  UserProviderData.changeActiveChildAbsence = useCallback(
    async (childData, absId = null) => {
      if (!!childData?.absences) {
        let absSickness = childData?.absences?.find(
          abs => abs.type == "sickness" && abs?.status == "sick",
        );

        if (!!absId) {
          absSickness = childData?.absences?.find(
            abs =>
              abs.type == "sickness" &&
              abs?.status == "sick" &&
              abs?._id == absId,
          );
        }

        setUser({ ...user, activeChildAbsences: childData?.absences });

        if (absSickness) {
          const isAbsCreatedBeforeNow = isDateBeforeToday(
            absSickness?.date_from,
          );
          if (isAbsCreatedBeforeNow) {
            setUser({
              ...user,
              activeChildSicknessAbs: absSickness,
              activeChildHasSickness: true,
            });
          }
        }
        return absSickness;
      } else {
        return null;
      }
    },
    [user],
  );

  UserProviderData.changeChildByID = useCallback(
    async (childID, absId = null) => {
      let localUser = _local.getLocalUser();

      if (localUser?.role == "parent") {
        setChildChange(true);
        let parentChildren = user?.students || [];
        if (parentChildren?.length == 0) {
          try {
            parentChildren = await api.users.getParentChildren(localUser?._id);
          } catch (err) {
            console.error(err);
          }
        }
        const child = parentChildren?.find(child => child?._id == childID);
        _local.setLocalActiveChild(child);
        let newUser = { ...user, students: parentChildren, activeChild: child };
        setUser(newUser);

        let notifs = user?.childsNotifications || [];
        try {
          const result = await api.notifications.parent.getChildNotifications(
            getObjId(localUser),
            childID,
          );
          if (!!result) {
            const hasChild =
              !!result && notifs?.find(n => getObjId(n) == getObjId(result));
            notifs = !!hasChild
              ? notifs?.map(n => (getObjId(n) == getObjId(result) ? result : n))
              : [...notifs, result];
            setUser({ ...newUser, childsNotifications: notifs });
          }
        } catch (err) {
          console.error(err);
        }

        UserProviderData.changeActiveChildAbsence(child, absId);
        return child;
      } else {
        return null;
      }
    },
    [user],
  );

  UserProviderData.getChildrenList = useCallback(() => {
    if (user?.students && user?.role == "parent") {
      return user?.students;
    } else {
      return [];
    }
  }, [user?.students, user?.role]);

  /* Notifications */

  // for mobile parent + children
  UserProviderData.getChildNotification = useCallback(
    async childID => {
      const localUser = _local.getLocalUser();
      const localChild = _local.getLocalChild();
      const localChildID = (!!childID && childID) || getObjId(localChild);
      if (!!localUser?._id && !!localChild && localUser?.role == "parent") {
        setToken(localUser?.token);

        let prevNotif = user?.childsNotifications || [];
        const hasChild = prevNotif.some(ch => getObjId(ch) == localChildID);
        //console.log("UserProviderData.getChildNotification");
        try {
          const result = await api.notifications.parent.getChildNotifications(
            getObjId(localUser),
            localChildID,
          );
          if (!!result) {
            if (!!hasChild) {
              prevNotif = prevNotif?.map(ch => {
                if (getObjId(ch) == localChildID) {
                  return result;
                } else {
                  return ch;
                }
              });
            } else {
              prevNotif.push(result);
            }

            setUser({ ...user, childsNotifications: prevNotif });
          }
        } catch (err) {
          console.error(err);
        }

        return prevNotif;
      } else {
        setUser({ ...user, childsNotifications: [] });
        return false;
      }
    },
    [setToken, api.setAuthorizationHeader, user],
  );

  UserProviderData.getChildrenNotifications = useCallback(
    async newUser => {
      const localUser = _local.getLocalUser();
      if (!!localUser?._id && localUser?.role == "parent") {
        setToken(localUser?.token);

        try {
          const result = await api.notifications.parent.getChildrenNotifications(
            getObjId(localUser),
          );
          if (!!result) {
            const rootUser = (!!newUser && newUser) || user;
            setUser({
              ...rootUser,
              childsNotifications: result,
              schoolsNotifications: [],
            });
            return result;
          }
        } catch (err) {
          console.error(err);
          return [];
        }
      } else {
        setUser({ ...user, childsNotifications: [] });
        return false;
      }
    },
    [setToken, api.setAuthorizationHeader, user],
  );

  // for mobile teacher + schools
  UserProviderData.getSchoolNotification = useCallback(
    async schoolKey => {
      const localUser = _local.getLocalUser();
      const localSchool = _local.getLocalSchool();
      const localSchoolKey = (!!schoolKey && schoolKey) || localSchool?.key;
      if (!!localUser?._id && localUser?.role == "teacher") {
        setToken(localUser?.token);

        let prevNotif = user?.schoolsNotifications || [];
        const hasSchool = prevNotif.some(ch => ch?.key == localSchoolKey);
        try {
          const result = await api.notifications.teacher.getSchoolNotifications(
            getObjId(localUser),
            localSchoolKey,
          );
          if (!!hasSchool) {
            prevNotif = prevNotif?.map(ch => {
              if (ch?.key == localSchoolKey) {
                return result;
              } else {
                return ch;
              }
            });
          } else {
            prevNotif.push(result);
          }

          setUser({ ...user, schoolsNotifications: prevNotif });

          return result;
        } catch (err) {
          console.error(err);
          return [];
        }
      } else {
        setUser({ ...user, schoolsNotifications: [] });
        return false;
      }
    },
    [setToken, api.setAuthorizationHeader, user],
  );

  UserProviderData.getSchoolsNotifications = useCallback(
    async newUser => {
      const localUser = _local.getLocalUser();
      if (!!localUser?._id && localUser?.role == "teacher") {
        setToken(localUser?.token);

        try {
          const result = await api.notifications.teacher.getSchoolsNotifications(
            getObjId(localUser),
          );

          const rootUser = (!!newUser && newUser) || user;
          setUser({
            ...rootUser,
            schoolsNotifications: result,
            childsNotifications: [],
          });

          return result || [];
        } catch (err) {
          console.error(err);
          return [];
        }
      } else {
        setUser({ ...user, schoolsNotifications: [] });
        return false;
      }
    },
    [setToken, api.setAuthorizationHeader, user],
  );

  UserProviderData.getInintNotifications = useCallback(async () => {
    const localUser = _local.getLocalUser();
    if (!!localUser?._id) {
      setToken(localUser?.token);

      if (localUser?.role == "parent") {
        await UserProviderData.getChildrenNotifications();
      } else if (localUser?.role == "teacher") {
        await UserProviderData.getSchoolsNotifications();
      }
    }
  }, [setToken, api.setAuthorizationHeader]);

  /**
   * User Children Absences
   */
  UserProviderData.setAmountAbsence = useCallback(
    amount => {
      setUser({ ...user, amountAbsences: amount });
    },
    [user],
  );

  // INFO: only for web
  UserProviderData.getAmountAbsence = useCallback(async () => {
    const localUser = _local.getLocalUser();

    if (localUser?._id && appHelper.isWeb) {
      setToken(localUser?.token);
      //  api.setAuthorizationHeader(localUser?.token);
      api.route.fetchAll(`absence/pending`).then(result => {
        const listResult = result?.data || result;
        const finishedList =
          listResult?.filter(abs => {
            if (
              abs?.status == "accepted" ||
              abs?.status == "sickness-finish" ||
              abs?.status == "refused"
            ) {
              return abs;
            }
          }) || [];
        const otherList =
          listResult?.filter(abs => !finishedList?.includes(abs)) || [];
        setUser({ ...user, amountAbsences: otherList?.length || 0 });
      });
    }
  }, [user]);

  /**
   * Other
   */
  UserProviderData.logOut = useCallback(async () => {
    _local.setLocalData("logout", true);

    if (!appHelper.isWeb) {
      console.debug("Capacitor - logOut");
      appPushNotifications.removeToken(user);
    }

    setChildChange(false);
    setUser(initState);

    _local.removeLocalUser();
    _local.removeLocalSchool();
    _local.removeLocalChild();

    // Reset Status Bar
    (!!appHelper?.isAndroid || !!appHelper?.isIos) && appStatusBar?.setStatusBarBackgroundColor();

    const logOutTimer = setTimeout(function() {
      //window.location.href = '/login';
      history.push("/login");
    }, 0);
    setLogOutTimer(logOutTimer);

    return true;
  }, [setLogOutTimer, isMobile, appHelper.isWeb, setUser, user, initState]);

  UserProviderData.swichRole = useCallback(async () => {
    // we get the campaigns linked to the user
    let isApp = false;
    if (!appHelper.isWeb || isMobile) {
      isApp = true;
    }

    _local.removeLocalUser();
    _local.removeLocalSchool();
    _local.removeLocalChild();

    setChildChange(false);
    setUser(initState);

    const logOutTimer = setTimeout(() => {
      // window.location.href = '/login';
      history.push({ pathname: `/login` });
    }, 0);
    setLogOutTimer(logOutTimer);
    return true;
  }, [isMobile, appHelper.isWeb, setUser, initState]);

  /**
   * User Context ROOT
   */
  return (
    <UserContext.Provider
      value={{
        ...user,
        ...UserProviderData,

        // token
        token,

        childChange,
        setChildChange,

        pushNotifData,
        setPushNotifData,
      }}
    >
      <UserDispatchContext.Provider value={setUser}>
        {children}
      </UserDispatchContext.Provider>
    </UserContext.Provider>
  );
};

export default withTranslation()(UserProvider);

/**
 * User Context HOOK
 */
export const withUser = Component => props => (
  <UserContext.Consumer>
    {store => <Component user={store} {...props} />}
  </UserContext.Consumer>
);

/**
 * User Context HOOK FUNCTIONS
 */

export function useSetUserData() {
  const user = useStateUser();
  const setUserD = useDispatchUser();
  return newUserData => {
    setUserD({ ...user, ...newUserData });
  };
}

export function useUserPatchData() {
  const user = useStateUser();
  return newUserData => {
    const userId = newUserData?._id ? newUserData?._id : user?._id;
    return (
      !!userId &&
      user.patchUser({
        _id: userId,
        ...newUserData,
      })
    );
  };
}

export function useCheckPushNotificationParameters() {
  const user = useStateUser();
  return params => {
    if (Object.keys(params).length > 0) {
      user.setPushNotifData(params);
    }
    return params;
  };
}

export function useActiveChildHasSickness() {
  const user = useStateUser();
  return () => user.activeChildHasSickness;
}

export function useActiveChildAbsences() {
  const user = useStateUser();
  return () => user.activeChildAbsences;
}

export function useChangeActiveChildHasSickness() {
  const user = useStateUser();
  return status => user.setActiveChildHasSickness(status);
}

export function useLogout() {
  const user = useStateUser();
  // const setUserD = useDispatchUser();
  return async () => {
    return await user.logOut();
  };
}

export function useActiveChildSicknessAbs() {
  const user = useStateUser();
  // const setUserD = useDispatchUser();
  return () => {
    return user?.activeChildSicknessAbs;
  };
}

export function useGetUserChildren() {
  const user = useStateUser();
  return () => {
    return user?.students || [];
  };
}

export function useInitUser() {
  const user = useStateUser();
  return async () => await user.initUser();
}

export function useAskPermissionOnDevice() {
  const user = useStateUser();
  return () => user.askPermissionsOnDevice();
}

export function useChangeChildByID() {
  const user = useStateUser();
  return child => user.changeChildByID(child);
}

export function useHasChildChange() {
  const user = useStateUser();
  return () => user.childChange;
}
export function useHasChildChangeAction() {
  const user = useStateUser();
  return boolValue => user.setChildChange(boolValue);
}

export function useGetInintNotifications() {
  const user = useStateUser();
  return async () => await user.getInintNotifications();
}

/* Parent */
export function useGetChildNotification() {
  const user = useStateUser();
  console.log("useGetChildNotification");
  return async childID => await user.getChildNotification(childID);
}

/* Teacher */
export function useGetSchoolNotification() {
  const user = useStateUser();
  return async schoolKey => await user.getSchoolNotification(schoolKey);
}
